
import React from 'react';
import { Check, AlertCircle } from 'lucide-react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

interface SpotifyUrlInputProps {
  spotifyUrl: string;
  isUrlValid: boolean;
  onChange: (url: string) => void;
  isPreviewLoading?: boolean;
  onPreview?: () => Promise<void>;
  hidePreview?: boolean;
}

const SpotifyUrlInput: React.FC<SpotifyUrlInputProps> = ({
  spotifyUrl,
  isUrlValid,
  onChange,
  isPreviewLoading,
  onPreview,
  hidePreview
}) => {
  return (
    <div className="space-y-3">
      <div className="flex flex-col space-y-2">
        <Label htmlFor="spotify-url">Spotify Track Link</Label>
        <div className="relative w-full">
          <Input
            id="spotify-url"
            type="text"
            placeholder="https://open.spotify.com/track/..."
            value={spotifyUrl}
            onChange={(e) => onChange(e.target.value)}
            className={`pr-10 ${!isUrlValid && spotifyUrl ? 'border-destructive' : ''}`}
          />
          {spotifyUrl && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2">
              {isUrlValid ? (
                <Check className="text-green-500 h-4 w-4" />
              ) : (
                <AlertCircle className="text-destructive h-4 w-4" />
              )}
            </div>
          )}
        </div>
        
        {!isUrlValid && spotifyUrl && (
          <p className="text-sm text-destructive">
            Please enter a valid Spotify track URL
          </p>
        )}
      </div>
    </div>
  );
}

export default SpotifyUrlInput;

